import React from 'react';
import { Question } from '../../molecules';
import { Title, Wrapper, Header, Content } from './styled';
import { formatData } from '../../../helpers/formatClientQuestionsData';
import { ICustomerQuestionProps } from '../../../types';

export const CustomerQuestion = ({ customerQuestions, hasCustomerQuestions, isDesk }: ICustomerQuestionProps) => {
  if (!hasCustomerQuestions) {
    return <></>;
  }

  const dataQuestion = formatData(customerQuestions);

  return (
    <>
      <Header isDesk={isDesk}>
        <Title isDesk={isDesk}>Suas perguntas</Title>
      </Header>
      <Content isDesk={isDesk}>
        <Wrapper>
          <Question
            isDesk={isDesk}
            key={dataQuestion?.question?.id}
            question={dataQuestion}
            term=""
            totalTermFound={10}
            isLast={false}
          />
        </Wrapper>
      </Content>
    </>
  );
};

export default CustomerQuestion;
